import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import EcoSweeps from "./components/EcoSweeps";
import PlatformDetailPage from "./components/PlatformDetailPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<EcoSweeps />} />
          <Route path="/platforms/:slug" element={<PlatformDetailPage />} />
          <Route path="*" element={<EcoSweeps />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
